export default __webpack_public_path__ + "images/060b2710bdbbe3dfe48b58d59bd5f1fb.svg";